import { render, staticRenderFns } from "./ElTribeBoxForm.vue?vue&type=template&id=d33b619a&"
import script from "./ElTribeBoxForm.vue?vue&type=script&lang=js&"
export * from "./ElTribeBoxForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d33b619a')) {
      api.createRecord('d33b619a', component.options)
    } else {
      api.reload('d33b619a', component.options)
    }
    module.hot.accept("./ElTribeBoxForm.vue?vue&type=template&id=d33b619a&", function () {
      api.rerender('d33b619a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/forms/ElTribeBoxForm.vue"
export default component.exports